<template>
  <div class="ListGerenteMarketplaces">
    <HeaderPage>
      <el-button style="height: 44px; margin-left: 1rem" @click="() => { $router.push({name: 'records.gerentemarketplaces.create'}) }" native-type="submit">Adicionar</el-button>
    </HeaderPage>
    <el-card v-loading="loadingPage">
      <FilterBox v-on:filter="listGerenteMarketplaces" :currentPage="listData.meta ? listData.meta.pagination.current_page : 1" />
      <TableSimple :list-data="listData" @paginationClick="paginationClick" :dblclick="(el) => {$router.push({name: 'records.gerentemarketplaces.edit', params: { id: el.id }})}">
        <el-table-column prop="person.name" label="Nome" />
        <el-table-column prop="person.cpf" label="CPF" />
        <el-table-column width="55">
          <template slot-scope="scope">
            <el-button type="text" @click="editMkt(scope.row.id)">
              <EditIcon size="1.2x" style="padding: 0 7px;"></EditIcon>
            </el-button>
          </template>
        </el-table-column>
      </TableSimple>
    </el-card>
  </div>
</template>

<script>
import HeaderPage from "@/app/components/HeaderPage";
import TableSimple from "@/app/components/Table/TableSimple";
import {getGerenteMarketplaces} from "@/app/domains/Records/services";
import {EditIcon} from "vue-feather-icons";
import FilterBox from './_filterBox'

export default {
  name: "ListGerenteMarketplaces",
  components: {
    HeaderPage,
    TableSimple,
    EditIcon,
    FilterBox,
  },
  data () {
    return {
      loadingPage: false,
      listData: {}
    }
  },
  methods: {
    init () {
      this.listGerenteMarketplaces()
    },
    editMkt (id) {
      this.$router.push({name: 'records.gerentemarketplaces.edit', params: { id: id }})
    },
    paginationClick (arg) {
      this.listGerenteMarketplaces('?page='+arg.page)
    },
    async listGerenteMarketplaces (query = '') {
      this.loadingPage = true
      try {
        let response = await getGerenteMarketplaces(query)
        this.listData = response.data
      } catch (e) {
        this.$message({
          showClose: true,
          message: e.message,
          type: 'error'
        })
      } finally {
        this.loadingPage = false
      }
    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style scoped>

</style>
